<boma-crud-table
  (changePageClicked)="handleChangePageClicked($event)"
  (queryChanged)="search($event)"
  (viewSelection)="onView($event)"
  [allowDelete]="false"
  [data]="users$ | async"
  [displaySearchBar]="true"
  [headersValue]="'User'"
  key="archivedUsers"
  [itemsPerPage]="perPage"
  [customActions]="customActions"
  (customAction)="restoreUser($event)"
  [loaded]="loading$ | async"
  [paginationData]="paginationData$ | async"
  [searchBarPlaceHolder]="'Search Archived Users'"
  [selectableColumns]="columns"
  [singularTerm]="'User'"
  [viewable]="true"
>
</boma-crud-table>

